import type { App } from "vue";
import installQuasar from "./quasar";
import installPinia from "./pinia";
import { useAuthStore } from "@/store/auth-store";

export * from "./quasar";
export * from "./pinia";
export * from "./api";

/**
 * Installs Quasar and Pinia plugins on the provided app.
 *
 * @param app The app to install plugins on.
 * @returns The app with Quasar and Pinia installed.
 */
export default function installPlugins(app: App) {
  installQuasar(app);
  installPinia(app);

  const globalProperties = app.config.globalProperties;
  globalProperties.$tl = (key: string) => key;
  globalProperties.$tg = (key: string) => key;
  globalProperties.$lang = {};
  globalProperties.$authService = useAuthStore();

  return app;
}
